import React from "react";
import PropTypes from "prop-types";
import { CheckIcon } from "../icons";

function Checkbox({ id, label, parameter, checked, onChange }) {
  return (
    <label htmlFor={id} className="m-checkbox">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={() => onChange({ [parameter]: checked ? 0 : 1 })}
        className="m-checkbox__input"
      />
      <span className="m-checkbox__checkbox">
        {checked && <CheckIcon className="m-checkbox__check-icon" />}
      </span>
      <span className="m-checkbox__label">{label}</span>
    </label>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  parameter: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
}.isRequired;

export default Checkbox;
